import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { EventsPage } from '../events/events';

/**
 * Generated class for the EventNextPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-event-next',
  templateUrl: 'event-next.html',
})
export class EventNextPage {
event_time:any;
event_name:string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  Cancel()
  {
    this.navCtrl.push(EventsPage);
  }
  SaveEvent()
  {
    //save function needs to be implemented
    this.navCtrl.push(EventsPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/event-next/event-next.ts